import actionTypes from './types'

/**
 * Store the contests with laps, newest first
 * @param {Array<Object>} contests contests from the API
 * @returns {Object} action
 */
export const setContests = ( contests = [] ) => ( {
  type: actionTypes.SET_CONTESTS,
  payload: contests
} )

/**
 * Choose the race to show
 * @param {number} id race id, 0 to follow the newest race
 * @param {number} newest newest race in the list now; a newer one later means following the newest again
 * @returns {Object} action
 */
export const selectContest = ( id = 0, newest = 0 ) => ( {
  type: actionTypes.SELECT_CONTEST,
  payload: { id, newest }
} )
